import React from 'react';

const OrgContext = React.createContext<Org | undefined>(undefined);
OrgContext.displayName = 'OrgContext';

export type Org = {
  id: string;
  name?: string;
  logo?: string;
  ownerId?: string;
  roles?: {
    id: {
      id: string;
    };
    name?: string;
    active?: boolean;
  }[];
  groups?: {
    id: {
      id: string;
    };
    name: string;
  }[];
};

export const OrgProvider = ({ org, children }: { org?: Org; children: React.ReactNode }) => (
  <OrgContext.Provider value={org}>{children}</OrgContext.Provider>
);

export default OrgContext;
